import { SegmentedControl } from '@/components/ui/controls'
import type { SpaceKind } from '@/data/types'
import { cn } from '@/lib/utils'

/**
 * Projects or areas, on top of a list of spaces.
 *
 * Two tabs, and no "All". A mixed list is the thing this control exists to fix:
 * four live deals and two standing accounts in one column, sorted by name, with
 * nothing but a three-letter code to say which is which. Offering "All" as the
 * default put everyone straight back into that list and made the split
 * something you had to opt into.
 *
 * Projects lead because that is where the work is. An area is a place things
 * accumulate; a project is a thing someone is in the middle of.
 *
 * Shared rather than repeated because the pickers are the same control in
 * different places, and the moment one of them renames a tab the others have to
 * follow.
 */
export function SpaceKindTabs({
  value,
  onChange,
  className,
}: {
  value: SpaceKind
  onChange: (value: SpaceKind) => void
  className?: string
}) {
  return (
    <SegmentedControl
      size="sm"
      className={cn('w-full [&>button]:flex-1', className)}
      value={value}
      onValueChange={onChange}
      options={[
        { value: 'project', label: 'Projects', title: 'Work that finishes' },
        { value: 'area', label: 'Areas', title: 'Relationships that run on' },
      ]}
    />
  )
}

/** What a space list opens on. */
export const DEFAULT_SPACE_KIND: SpaceKind = 'project'

export function filterByKind<T extends { kind: SpaceKind }>(spaces: T[], kind: SpaceKind): T[] {
  return spaces.filter((space) => space.kind === kind)
}
